import Home from '../components/pages/home/Home'
import NotFound from '../components/pages/404/NotFound'
import LeadGenLanding from '../components/pages/leadgen/LeadGenLanding'

const routes = [
    {
      id: 'home',
      name: 'home',
      path: '/',
      exact: true,
      protected: false,
      component: Home,
    },
    {
      id: 'leadgen',
      name: 'leadgen',
      path: '/lg/tps',
      exact: true,
      protected: false,
      component: LeadGenLanding,
    },
    /* Error route */
    {
      id: '404',
      name: 'Not Found',
      path: '*',
      exact: true,
      protected: false,
      component: NotFound,
    },
]; 

export default routes;
